module.exports = __webpack_public_path__ + "img/series_tweed_pattern.9dc0fcc9.png";